import { useContext, useState } from 'react'
import { ProductContext } from '../contexts/ProductContext'

export default function useMetadataForm(metadata, initialValues = {}) {
  const productContext = useContext(ProductContext)
  const { product } = productContext

  const initialPrice = /^\d*$/.test(product.price) ? Number(product.price).toFixed() : ''

  const [bundleTitle, setBundleTitle] = useState(product.name || '')
  const [bundlePrice, setBundlePrice] = useState(initialPrice)
  const [bundleDescription, setBundleDescription] = useState(product.description || '')
  const [isPublishing, setIsPublishing] = useState(false)
  const [bundlePriceValidation, setBundlePriceValidation] = useState(null)

  // TODO: I do not have autosave working but worth leaving here if we want to explore later

  // const {
  //   isReady,
  //   patch,
  //   values,
  //   isPatching,
  //   form
  // } = useAutosaveForm({
  //   item: metadata,
  //   initialValues,
  //   resourceContext: productContext,
  //   onUpdate: (updated) => {}
  // })

  return {
    // ...form,
    // patch,
    // isPatching,
    // values,
    // isReady,
    isPublishing,
    setIsPublishing,
    bundleTitle,
    setBundleTitle,
    bundlePrice,
    setBundlePrice,
    bundleDescription,
    setBundleDescription,
    bundlePriceValidation,
    setBundlePriceValidation,
  }
}
